import { storageModel } from "../libs/storage-manager";

export const themes = {
  Light: {
    "--background-color": "#ffffff",
    "--text-color": "#000000",
    "--item-background-color": "#ffffff",
    "--border-color": "#F2F2F2",
    "--card-background": "#ffffff",
    "--title-bg": "#EEF2F9",
  },
  Dark: {
    "--background-color": "#121212",
    "--text-color": "#f5f5f5",
    "--item-background-color": "#1C1C1E",
    "--border-color": "#4D4D4D",
    "--card-background": "rgba(30,38,58,0.96)",
    "--title-bg": "rgba(255,255,255,0.1)",
  },
  extend: {
    colors: {
      "spring-green": "#4CAF50",
      "spring-green-light": "#81C784",
      "spring-pink": "#F48FB1",
      "spring-sky": "#64B5F6",
      "spring-yellow": "#FFD54F",
      "spring-orange": "#FFB74D",
      "spring-bg": "#FFF8E1",
      "spring-text": "#3E2723",
    },
    fontFamily: {
      noto: ["Noto Sans TC", "sans-serif"],
    },
    backgroundImage: {
      "gradient-spring":
        "linear-gradient(180deg, #E8F5E9 0%, #FFF8E1 50%, #FFECB3 100%)",
    },
  },
};

export const isDarkMode =
  typeof localStorage !== "undefined" ? storageModel.isDarkMode === "Y" : false;

if (typeof document !== "undefined") {
  const activeTheme = isDarkMode ? themes.Dark : themes.Light;
  Object.keys(activeTheme).forEach((property: string) => {
    document.documentElement.style.setProperty(
      property,
      activeTheme[property as keyof typeof activeTheme],
    );
  });
}
